import { createContext, useContext, useEffect, useMemo, useState, useCallback } from 'react';
import { DICT, LANGS } from '@/i18n/dictionaries';

const I18nContext = createContext(null);

const STORAGE_KEY = 'okv_lang';

const detectDefault = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored && DICT[stored]) return stored;
        const nav = (navigator?.language || 'es').slice(0, 2);
        if (DICT[nav]) return nav;
    } catch (_) {}
    return 'es';
};

export const I18nProvider = ({ children }) => {
    const [lang, setLangState] = useState(detectDefault);

    const setLang = useCallback((l) => {
        if (!DICT[l]) return;
        setLangState(l);
        try { localStorage.setItem(STORAGE_KEY, l); } catch (_) {}
        try { document.documentElement.setAttribute('lang', l); } catch (_) {}
    }, []);

    useEffect(() => {
        try { document.documentElement.setAttribute('lang', lang); } catch (_) {}
    }, [lang]);

    const t = useCallback((key, fallback) => {
        const table = DICT[lang] || DICT.es;
        return table[key] || DICT.es[key] || fallback || key;
    }, [lang]);

    const value = useMemo(() => ({ lang, setLang, t, langs: LANGS }), [lang, setLang, t]);
    return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
    const ctx = useContext(I18nContext);
    if (!ctx) return { lang: 'es', setLang: () => {}, t: (k, f) => f || k, langs: LANGS };
    return ctx;
};
